Sofoot.modules.forum = (() => {
    let forum, messages;
    return {
        /**
         * Affiche une notification (succès / erreur) via le design system
         */
        notifier(type, contenu) {
            if (!contenu) return;
            App?.modules?.notifications?.afficher({ type, contenu, transition: 'slide', autoclose: type == 'success' });
        },
        /**
         * Extrait le message d'erreur renvoyé par /api
         */
        messageErreur(error, defaut) {
            return error?.responseJSON?.message || defaut;
        },
        reponseLocale(message) {
            let txt = message.querySelector('div>div').innerHTML;
            let nom = message.querySelector('aside>div>span')?.innerText;
            let div = document.createElement('div');
            div.innerHTML = txt;
            div.querySelectorAll('blockquote, .citation, br, a').forEach(element => element.remove());
            let texte = div.innerHTML.trim();
            if (nom && texte) {
                texte = `[quote][b]${nom} a écrit[/b]\n${texte}[/quote]\n`;
            }
            return texte;
        },
        activerActions() {
            document.addEventListener('effacer-message-forum', e => {
                if (!m.compte.isAdmin()) {
                    window.open('https://www.youtube.com/watch?v=dQw4w9WgXcQ', '_self');
                    return;
                }
                // Le contrôle du rôle est refait côté serveur : on ne retire le message
                // du DOM que si l'API a bien accepté la suppression.
                _api.ajax({
                    url: '/api/forum/reponse/' + e.data.messageId,
                    method: 'DELETE'
                }).done(() => {
                    document.querySelector('[data-zone="reponse"][data-id="' + e.data.messageId + '"]')?.remove();
                    this.notifier('success', 'Le message a été mis à la corbeille.');
                }).fail(error => {
                    this.notifier('error', this.messageErreur(error, "Impossible d'effacer ce message."));
                });
            });
        },
        /**
         * Le template "editer" est interprété par getTemplate() comme un template
         * literal (eval) puis injecté en innerHTML : on neutralise le html et
         * l'interpolation pour que le texte du message reste du texte.
         */
        echapperTemplate(texte) {
            return (texte ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\\/g, '\\\\')
                .replace(/`/g, '\\`')
                .replace(/\$\{/g, '\\${');
        },
        activerEdition() {
            document.addEventListener('editer-message-forum', e => {
                let id = e.data.messageId;
                // On recharge le texte brut (citations comprises) plutôt que de repartir
                // du html affiché.
                _api.get('/api/forum/reponse/' + id + '/brut').done(message => {
                    e.module.ouvrirEditerReponse(id, this.echapperTemplate(message?.texte));
                }).fail(error => {
                    this.notifier('error', this.messageErreur(error, "Vous n'avez pas le droit de modifier ce message."));
                });
            });

            document.addEventListener('valider-editer-message-forum', e => {
                _api.post('/api/forum/reponse/' + e.data.id + '/modifier', { message: e.data.message }).done(reponse => {
                    e.module.fermerEditerReponse(reponse.html);
                    this.notifier('success', 'Le message a été modifié.');
                }).fail(error => {
                    let bouton = document.querySelector('[data-zone="editer"] button[type="submit"].btn');
                    if (bouton) delete bouton.dataset.loading;
                    this.notifier('error', this.messageErreur(error, 'Impossible de modifier ce message.'));
                });
            });
        },
        /**
         * Actions de modération portant sur l'auteur d'un message (masquer / bannir).
         * Le module forum du design system ne connaît que repondre/effacer/editer :
         * on écoute nous-mêmes les clics sur ces deux boutons.
         */
        activerActionsMembre() {
            document.addEventListener('click', e => {
                let bouton = e.target.closest('button[data-action$="-membre"]');
                if (!bouton || bouton.dataset.loading) return;
                let id = bouton.dataset.idMembre;
                if (!id) return;
                let nom = bouton.dataset.membre || 'ce membre';
                let action = bouton.dataset.action.replace('-membre', '');
                let questions = {
                    masquer: `Masquer ${nom} ? Tous ses messages disparaîtront du forum et il ne pourra plus poster.`,
                    bannir: `Bannir le compte de ${nom} ? Il ne pourra plus se connecter, mais ses messages resteront visibles.`,
                    debannir: `Débannir le compte de ${nom} ? Il pourra à nouveau se connecter.`,
                };
                let succes = {
                    masquer: `Les messages de ${nom} ont été masqués.`,
                    bannir: `Le compte de ${nom} a été banni.`,
                    debannir: `Le compte de ${nom} a été débanni.`,
                };
                if (!questions[action] || !confirm(questions[action])) return;
                bouton.dataset.loading = true;
                _api.post('/api/forum/membre/' + id + '/' + action).done(() => {
                    delete bouton.dataset.loading;
                    if (action == 'masquer') this.retirerMessagesMembre(id);
                    if (action != 'masquer') this.basculerBoutonBannissement(id, action == 'bannir');
                    this.notifier('success', succes[action]);
                }).fail(error => {
                    delete bouton.dataset.loading;
                    this.notifier('error', this.messageErreur(error, `Impossible d'agir sur le compte de ${nom}.`));
                });
            });
        },
        /**
         * Bascule les boutons bannir / débannir d'un membre après une action réussie :
         * le rendu serveur ne connaît l'état du compte qu'au chargement de la page.
         */
        basculerBoutonBannissement(id_membre, banni) {
            document.querySelectorAll(`button[data-action$="bannir-membre"][data-id-membre="${id_membre}"]`).forEach(bouton => {
                let nom = bouton.dataset.membre || 'ce membre';
                bouton.dataset.action = banni ? 'debannir-membre' : 'bannir-membre';
                // Le libellé passe par aria-label : c'est ce que lit le tooltip css (balloon)
                bouton.setAttribute('aria-label', banni ? `Débannir le compte de ${nom}` : `Bannir le compte de ${nom}`);
                let span = bouton.closest('span');
                if (span) span.dataset.zone = banni ? 'action-debannir' : 'action-bannir';
                let use = bouton.querySelector('use');
                if (use) use.setAttribute('xlink:href', banni ? '#tick' : '#lock');
            });
        },
        /**
         * Retire du dom les messages d'un membre qui vient d'être masqué : au rechargement
         * l'api ne les renverra plus.
         */
        retirerMessagesMembre(id_membre) {
            document.querySelectorAll('[data-zone="reponse"]').forEach(message => {
                if (message.querySelector(`button[data-id-membre="${id_membre}"]`)) {
                    message.remove();
                }
            });
        },
        activerReponse() {
            document.addEventListener('rediger-message-forum', e => {
                let message = document.querySelector(`article[data-id="${e.data.messageId}"]`);
                message.scrollIntoView();
                _api.get('/api/forum/reponse/' + message.dataset.id).then(message => {
                    let texte = message?.texte ? `[quote][b]${message.name} a écrit[/b]\n${message.texte}[/quote]\n` : '';
                    e.module.ouvrirRedigerReponse(texte);
                }).fail(() => {
                    e.module.ouvrirRedigerReponse('');
                })
                // if (message.dataset.editable) {
                // } else {
                //     e.module.ouvrirRedigerReponse(this.reponseLocale(message));
                // }
            });

            document.addEventListener('valider-rediger-message-forum', e => {
                _api.post('/api/forum/reponse', e.data).done(response => {
                    e.module.fermerRedigerReponse();
                    document.location.href = response.url;
                    if (document.location.href.split('#')[0] == response.url.split('#')[0]) {
                        document.location.reload();
                    }
                }).fail(error => {
                    console.log(error)
                })
            })

            window.addEventListener('hashchange', (e) => {
                let hash = document.location.hash.replace('#');
                console.log('hashchange', hash)
                let ancre = document.querySelector(`a[name="${hash}"]`);
                if (ancre) {
                    ancre.scrollIntoView();
                }
            })

        },

        start() {
            forum = document.querySelector('[data-zone="forum"]');
            if (forum) {
                messages = forum.querySelector('[data-zone="messages"]');
                if (messages) {
                    this.activerReponse()
                    this.activerActions()
                    this.activerEdition()
                    this.activerActionsMembre()
                }
            }
        }
    }

})();
